import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LocalisationService } from './localisation.service';
import { MatchTeam } from './match-team.model';
import { SPORTS } from './sports';
import { BlockConfigurationObject } from "./block-configuration-object.model";
import { BetService } from './bet.service';

@Injectable({
  providedIn: 'root'
})
export class BlockConfigService {

  constructor(
    private localisationService: LocalisationService,
    private betService: BetService,
    private router: Router
  ) { }

  getGlobalBlockConfig(): BlockConfigurationObject {
    return {
      terminologyLocale: this.localisationService.getLocaleObject().blockLocaleCode,
      teamLogoDefault: "custom",
      apiDomain: environment.apiDomain,
      customTeamLogoFunction: (team: MatchTeam, sportCode: string): string => {
        if (this.localisationService.sportPrioritySort(SPORTS).some(s => s.code === sportCode.toUpperCase())) {
          const sport = SPORTS.find(s => s.code === sportCode.toUpperCase());
          if (environment.officialLogoSports.includes(sportCode.toUpperCase())) {
            return `https://cdn.ciphersports.io/images/${ sport.code }/official/${ team[sport.jerseyFileKey] }.svg`;
          } else {
            const fileExtension = sport.code === "EURO" ? "png" : "svg";
            return `https://cdn.ciphersports.io/images/${ sport.code }/${ team[sport.jerseyFileKey] }.${fileExtension}`;
          }
        }
        return "";
      },
      matchLinkFunction: function(matchid: string) {
        if (!matchid) return "";
        var segments = matchid.toLowerCase().split(/_(.+)/);
        return `/sport-hub/${segments[0]}/schedule/${segments[1]}`;
      },
      //bookmakerTheme: "betstreet",
      bookmakers: environment.bookmakers,
      customBookmakerLinks: this.betService.customBookmakerLinks,
      teamDisplayNameDefault: "nickname",
      liveSportsAvailable: this.localisationService.sportPrioritySort(SPORTS).filter(s => environment.liveCoverageSports.includes(s.code)).map(s => s.code),
      applyUserProximityWeighting: true,
      allowShortlisting: environment.auth0Domain ? true : false,
      oddsDisplayFormat: this.localisationService.getLocaleObject().oddsDisplayFormat,
      showGamblingInformation: true,
      matchFirstTeam: environment.matchFirstTeam,
      showBestParlay: false,
      futuresLinkFunction: function(sport: string) {
        return `/futures/${sport}`;
      },
      fixtureLinkFunction: function(sport: string) {
        if (!sport) return "";
        // don't link to the fixtures for State of Origin
        if (sport.toUpperCase() === "SOO") return "";
        return "/sport-hub/" + sport.toLowerCase() + "/schedule";
      },
      valueBetsLink: "/best-bets",
      temperatureDisplay: environment.temperatureDisplay,
      linkCallback: (href) => {
        this.router.navigateByUrl(href)
      },
      showExtraFuturesMarkets: true,
      showSetBetting: false,
      sportExclusiveBookmakers: environment.sportExclusiveBookmakers,
      useDeepBookmakerLinks: true,
    }
  }
}
